import athenaConfig from '../config';
import { getRequestState } from './widget-facade';
import { autoSubmitPostForm } from './html-utils';
import { isDirectOhswAdjacentAuthClient } from './app-utils';


export async function launchLwa({ emailToken, hash, error_details, identifier }:
  { emailToken?: string; hash?: string; error_details?: string; identifier?: string }) {
  const { postToOkta } = global.settings;
  const { lwaBaseUri, authServerId } = athenaConfig;

  const lwaAuthorizeUrl = new URL(`oauth2/${authServerId}/v1/authorize`, lwaBaseUri);

  hash && (lwaAuthorizeUrl.hash = hash);
  if (postToOkta) {
    const state = JSON.parse(getRequestState()) as Record<string, any>;
    const originalAuthorizeParams = state.authorizePostParamsObject as Record<string, string>;
    const params = { ...originalAuthorizeParams };
    if (emailToken) {
      params.registration_token = emailToken;
    }
    if (error_details) {
      params.error_details = error_details;
    }
    autoSubmitPostForm({ action: lwaAuthorizeUrl.toString(), params });
  }
  else {
    const { originalRedirectUri } = global.settings;
    if (originalRedirectUri) {
      const queryParams = originalRedirectUri.searchParams;
      for (const [ key, value ] of queryParams) {
        lwaAuthorizeUrl.searchParams.set(key, value);
      }
      // registration_token has highest priority over other token params,
      // so use this in case there is another email token in the URL already
      emailToken && lwaAuthorizeUrl?.searchParams.set('registration_token', emailToken);
      error_details && (lwaAuthorizeUrl.searchParams.set('error_details', error_details));
      window.location.assign(lwaAuthorizeUrl.toString());
    }
    else if (isDirectOhswAdjacentAuthClient()) {
      // Direct-OHSW adjacent auth apps authenticate directly via Okta
      // (no LWA state/originalRedirectUri), so build the authorize URL from the current
      // Okta request context.
      const requestContext = global.OktaUtil.getRequestContext();
      const authRequest = requestContext?.authentication?.request ?? {};
      const clientId = requestContext?.authentication?.client?.id;
      if (clientId && authRequest.redirect_uri) {
        lwaAuthorizeUrl.searchParams.set('client_id', clientId);
        lwaAuthorizeUrl.searchParams.set('redirect_uri', authRequest.redirect_uri);
        authRequest.response_type && lwaAuthorizeUrl.searchParams.set('response_type', authRequest.response_type);
        authRequest.scope && lwaAuthorizeUrl.searchParams.set('scope', authRequest.scope);
        authRequest.state && lwaAuthorizeUrl.searchParams.set('state', authRequest.state);
        authRequest.nonce && lwaAuthorizeUrl.searchParams.set('nonce', authRequest.nonce);
        authRequest.code_challenge && lwaAuthorizeUrl.searchParams.set('code_challenge', authRequest.code_challenge);
        authRequest.code_challenge_method && lwaAuthorizeUrl.searchParams.set('code_challenge_method', authRequest.code_challenge_method);
        error_details && lwaAuthorizeUrl.searchParams.set('error_details', error_details);
        identifier && lwaAuthorizeUrl.searchParams.set('identifier', identifier);
        window.location.assign(lwaAuthorizeUrl.toString());
      }
    }
  }
}
